import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
import {environment} from '../../../../../environments/environment';
import {VanBanDiXLService} from '../../../../service/vanbandi/service-vanbandixl';
import {Staffs} from '../../../../models/staff/staffs';
import {VanBanDi} from '../../../../models/vanbandi/vanbandi';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {FormatService} from '../../../../service/format/service-format';
import {NavItemService} from '../../../../service/staff/service-navitem';

@Component({
  templateUrl: './giaoxuly.component.html'

})
export class GXLVanBanDiComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public dateThoiHan: Date;
  public staffSingerList: Object[] =[];
  public staffsList: Staffs[]=[];
  public  onClose: Subject<boolean>;
  public vanBanDiItem: VanBanDi=new VanBanDi();

  constructor(
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public _bsModalRef: BsModalRef,
    public commandUtils: CommandUtil,
    public vanBanDiService: VanBanDiService,
    public formatService: FormatService

  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number) {
    this.id= id;
    this.isEdit =(id!=0)? true: false;
    this.vanBanDiService.getById(id).subscribe(data => this.vanBanDiItem = data);
    /*this.vanBanDiGiaoXLService.getAllByMaVB(id).pipe(first())
      .subscribe(x => {
       for(let i= 0;i< x.length;i++) {

          this.staffsList.push(x[i].nguoiXuLy);

       }
      });*/

  }
  public deleteItem(id: number)
  {
    this.staffsList.splice(this.staffsList.findIndex(x=> x.id === id),1);
  }
  ngOnInit(): void {

    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      maNguoiChuTri: new FormControl(),
      theoDoiCap2: new FormControl(),
      tuHoanThanh: new FormControl(),
      thoiHan: new FormControl(),
      butPhe: new FormControl()



    });
    this.frmGroup = this.formBuilder.group({
      maNguoiChuTri: ['' , Validators.compose([validateEmpty]) ],
      thoiHan: ['', Validators.nullValidator],
      tuHoanThanh: ['', Validators.nullValidator],
      theoDoiCap2: ['', Validators.nullValidator],
      butPhe: ['', Validators.nullValidator]
    });

  }
  get f() { return this.frmGroup.controls; }

  createItem ()
  {


   // this.selectedSingerList.length > 0 ? this.selectedSingerList[0] : 0;

  }
  public showSinger()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSingerList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for(let i= 0;i< result.length;i++)  {
          if(this.staffsList.findIndex(y=> y.id === result[i].id) === -1)
            this.staffsList.push((result[i]));
        }
      }
    });
  }


  public actionXuLy()
  {
   // this.formatService.getCompareDate(this.datepipe.transform(this.dateThoiHan, 'MM/dd/yyyy')).subscribe(
     // y => {
       // if (y > 0) {
          this.frmGroup.value.thoiHan = this.datepipe.transform(this.dateThoiHan, 'dd/MM/yyyy');
          this.vanBanDiService.addXuLy(this.id, this.staffsList.map(x=>x.id).join().toString(),
            (this.frmGroup.value.tuHoanThanh == true? 1 : 0),
            (this.frmGroup.value.theoDoiCap2 == true? 1 : 0),
            this.frmGroup.value.thoiHan,
            (this.frmGroup.value.maNguoiChuTri === ''? 0 : Number(this.frmGroup.value.maNguoiChuTri)),
            Number(environment.chuaxuly),
            Number(environment.chuaxuly),
            this.frmGroup.value.butPhe === '' ? '  ' : this.frmGroup.value.butPhe ,
            Sessioncommand.staffId
          ).subscribe(
            {    next: (data) => {
                this.toastr.success(language.dagiaoxulythanhcong, language.message);
                Sessioncommand.vanBanDiStatus = 0;
                Sessioncommand.notification = true;
                this.onSave();
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
        /*}else
        {
          this.toastr.error(language.message_thoihan_error, language.message);
        }
      });*/

  }
  public onSubmit()
  {
    this.submitValidate = true;

    if(this.frmGroup.invalid)
      return;
    this.actionXuLy();

  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

